import { useCallback, useEffect, useState } from 'react';

import { useFirebaseAuth } from '../components/global/FirebaseProvider/FirebaseProvider';
import { getConfigurations } from '../components/trashie/utils/service';

const useGetConfiguration = (configName) => {
  const { isLoading: isLoadingFirebaseAuth, isSignedIn } = useFirebaseAuth();

  const [isLoadingConfiguration, setIsLoadingConfiguration] = useState(true);
  const [configuration, setConfiguration] = useState(null);

  const loadConfiguration = useCallback(async () => {
    setIsLoadingConfiguration(true);
    const { value, error } = await getConfigurations(configName);

    if (error) {
      setConfiguration(null);
      setIsLoadingConfiguration(false);
      return;
    }

    setConfiguration(value);
    setIsLoadingConfiguration(false);
  }, []);

  useEffect(() => {
    if (!isLoadingFirebaseAuth && isSignedIn) {
      loadConfiguration();
    }
  }, [isLoadingFirebaseAuth, isSignedIn]);

  return {
    isLoading: isLoadingFirebaseAuth || isLoadingConfiguration,
    configuration,
  };
};

export default useGetConfiguration;
